import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { Platform } from "react-native";
import { db } from "./firebase";

export function trackActivity(
  type: "app_launch" | "login" | "sign_up",
  uid: string,
  email?: string | null
) {
  addDoc(collection(db, "activity"), {
    type,
    uid,
    email: email || null,
    platform: Platform.OS,
    timestamp: serverTimestamp(),
  }).catch(() => {}); // fire-and-forget
}
